import keyNames from "../../keyName";
export const initialState = {
  [keyNames.themeMode]: "light",
  [keyNames.apiErrors]: null,
  [keyNames.extra]: null,
  [keyNames.isLoading]: "noLoading",
  [keyNames.toastData]: null,
  [keyNames.userData]: null,
  [keyNames.forceLogOut]: false,
  [keyNames.registeredUserData]: null,
  [keyNames.dashboardData]: null,
  [keyNames.venuesData]: null,
  [keyNames.suitableVenuesData]: null,
  [keyNames.vendorData]: null,
  [keyNames.crmData]: null,
  [keyNames.leadsData]: null,
  [keyNames.venuePlanningData]: null,
  [keyNames.particularCrmData]: null,
  [keyNames.estimatesData]: null,
  [keyNames.uploadData]: null,
  [keyNames.attendeesData]: null,
};
